export default "__VITE_ASSET__CbkMgd2u__"